<cxone-modal [headerTitle]="headerTitle" (dismissed)="cancel()" [allowClose]="true" (closed)="save()"
    [saveDisabled]="!isDefinitionSelected" [cancelLabel]="cancelLabel" [saveLabel]="recalculateLabel" 
    *ngIf="isLocalizationSectionLoaded">
    <cxone-embedded-messages class="embedded-message" messageType="system-info" [messageData]="inProgressItemsInfo" id="system-info" *ngIf="metricsInProgress.length > 0 || reportingSetsInProgress.length > 0"></cxone-embedded-messages>
    <cxone-embedded-messages class="embedded-message" messageType="system-warning" [messageData]="warningMessage" id="system-warning" *ngIf="showWarningMsg"></cxone-embedded-messages>
    <label class="label-field allCaps" cvLocalizedText langSection="ETL_Recalculation_Modal" langKey="Date_Range">Date
        Range</label>
    <span class="question-icon" id="infoDateRangeIcon" container="body">
        <svg class="icon-16" [popover]="popoverTemplate" containerClass="cxone-popover" triggers="mouseenter:mouseleave"
            placement="right">
            <use href="../App_Themes/CXone/icons/question.svg#question"></use>
        </svg>
    </span>
    <div class="date-range-selector">
        <cxone-date-range-dropdown [dateRangeDropdownContainer]="'.modal-body-wrapper'"
            [filterOptions]="['CustomRange']" [dateRange]="dateRangeObj"
            [optionsWhereToShowDateOnDropdown]="['CustomRange']" [customRangeMinAndMax]="customDateRange"
            (dateRangeChanged)="onDateRangeChanged($event)" id="date-range-dropdown">
        </cxone-date-range-dropdown>
    </div>
    <div>
        <cxone-tabs class="element-tabs">
            <cxone-tab id="listView-tab" index="0" [title]="listViewLabel">
                <div>
                    <cxone-accordion [multiple]="false">
                        <span *ngIf="metricsView">
                            <cxone-accordion-tab [header]="listMetricView" [selected]="expandMetricsAccordian"
                                (toggle)="onClickAccordian($event)">
                                <cv-cxone-recalculation-metric-view [metricsInProgress]="metricsInProgress"
                                    (selectedMetricList)="getSelectedMetricList($event)"></cv-cxone-recalculation-metric-view>
                            </cxone-accordion-tab>
                        </span>
                        <span *ngIf="reportingSetsView">
                            <cxone-accordion-tab [header]="listReportingSetView"
                                [selected]="expandReportingSetAccordian" (toggle)="onClickAccordian($event)">
                                <cv-cxone-recalculation-reporting-set-view [reportingSetsInProgress]="reportingSetsInProgress"
                                    (selectedReportingSetList)="getSelectedReportingSetList($event)"></cv-cxone-recalculation-reporting-set-view>
                            </cxone-accordion-tab>
                        </span>
                    </cxone-accordion>
                </div>
            </cxone-tab>
            <cxone-tab id="detailedView-tab" index="1" [title]="detailedViewLabel">
                <div class="recalculation-grid-container">
                    <cxone-omnibar [itemCountLabel]="totalCount" [isFilterable]="false"
                        [searchPlaceholderText]="searchPlaceholderText"
                        (searchQueryChange)="onSearchCriteriaChange($event)" [searchQuery]="searchInput">
                        <cxone-omnibar-custom-content class="omnibar-custom-content-wrapper">
                            <div class="omnibar-custom-content">
                                <cxone-selected-tags></cxone-selected-tags>
                                <div class="metric-reporting-toggle" *ngIf="showToggleButtons">
                                    <toggle-button-group ngDefaultControl [options]="viewOptions"
                                        [initialValue]="viewOptions[0]" (onSelectedChange)="onClickToggle($event)">
                                    </toggle-button-group>
                                </div>
                            </div>
                        </cxone-omnibar-custom-content>
                    </cxone-omnibar>
                    <ng-container *ngIf="metricsGridView">
                        <cv-metric-detailed-view (totalCountLabel)="getTotalRowsCount($event) "
                            (selectedMetricList)="getSelectedMetricList($event)" (gridData)="getGridData($event)"
                            [searchInput]="searchInput" [metricsInProgress]="metricsInProgress"></cv-metric-detailed-view>
                    </ng-container>
                    <ng-container *ngIf="reportingSetsGridView">
                        <cv-reporting-set-detailed-view (totalCountLabel)="getTotalRowsCount($event) "
                            (selectedReportingSetList)="getSelectedReportingSetList($event)"
                            (gridData)="getGridData($event)"
                            [searchInput]="searchInput" [reportingSetsInProgress]="reportingSetsInProgress"></cv-reporting-set-detailed-view>
                    </ng-container>
                </div>
            </cxone-tab>
        </cxone-tabs>
    </div>
</cxone-modal>
<ng-template #popoverTemplate>
    <div class="popover-wrapper">
        <div class="message">{{dateRangeInfoMsg}}</div>
    </div>
</ng-template>